module.exports = __webpack_public_path__ + "img/sample-forecast-v2.bc26fe0e.jpg";